import script from "./searchFilesSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./searchFilesSelect.vue?vue&type=script&lang=ts&setup=true"

import "./searchFilesSelect.vue?vue&type=style&index=0&id=a9fb75c4&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9fb75c4"]])

export default __exports__